import $ from 'jquery';

export class FeaturesFolders {
  constructor( $container ) {
    this.$anchors = $container.find('.features-folders-pagination a');

    this.handleAnchors();
  }

  handleAnchors() {
    this.$anchors.each(function() {
      const $anchor = $(this);

      const elID = $anchor.attr('href');
      const $selector = $anchor.parents('.container').find(elID);
      const targetElement = $selector[0];
      const scrollElPos = targetElement.offsetTop + targetElement.clientHeight * 1.5;

      $anchor.on('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        window?.scroller.scrollTo(scrollElPos, {
          immediate: false,
          lock: true,
        })
      });
    });
  }
}
